import {
  API_FIELDS_APPLICATION as APPLICATION,
  API_FIELDS_APPLICATION_PET as APPLICATION_PET,
  API_FIELDS_APPLICATION_LANGUAGE as LANGUAGE,
} from '@enroller/admissions-components';

export const SCHOOL_AND_LANGUAGES_FIELDS = `
  ${APPLICATION.typeOfSchool} { value }
  ${APPLICATION.typeOfSchoolOther} { value }
  ${APPLICATION.gradeLevel} { value }
  ${APPLICATION.highestGradLevelSchool} { value }
  ${APPLICATION.graduationSituation} { value }
  ${APPLICATION.graduationDate} { value }
  ${APPLICATION.yearsOfEnglish} { value }
  ${APPLICATION.nativeLanguage} { value }
  ${APPLICATION.languageListGET} {
    _data {
      ${LANGUAGE.language} { value }
      ${LANGUAGE.id} { value }
      ${LANGUAGE.numberOfYears} { value }
    }
  }
`;

export const HOUSING_FIELDS = `
  ${APPLICATION.youngChildrenFeelings} { value }
  ${APPLICATION.attendReligiousServices} { value }
  ${APPLICATION.willAttendWithHostFamily} { value }
  ${APPLICATION.religiousPreference} { value }
  ${APPLICATION.religiousPreferenceOther} { value }
  ${APPLICATION.understandNoSmoking} { value }
  ${APPLICATION.adjustToSmokers} { value }
`;

export const PETS_FIELDS = `
  ${APPLICATION.doNotOwnPets} { value }
  ${APPLICATION.petsListGET} {
    _data {
      ${APPLICATION_PET.id} { value }
      ${APPLICATION_PET.name} { value }
      ${APPLICATION_PET.size} { value }
      ${APPLICATION_PET.type} { value }
    }
  }
  ${APPLICATION.adjustToIndoorPet} { value }
  ${APPLICATION.noIndoorPetExplanation} { value }
  ${APPLICATION.afraidOfPets} { value }
  ${APPLICATION.afraidOfPetExplanation} { value }
`;

export const PLACEMENT_FIELDS = `
  ${APPLICATION.acceptDoublePlacement} { value }
  ${APPLICATION.acceptSingleHost} { value }
  ${APPLICATION.acceptSameSexCouple} { value }
  ${APPLICATION.acceptSmallSchool} { value }
`;

export const FOOD_FIELDS = `
  ${APPLICATION.dietRestricted} { value }
  ${APPLICATION.prepareOwnMeals} { value }
  ${APPLICATION.adjustToVegetarian} { value }
`;

export const MEALS_FIELDS = `
  ${APPLICATION.specialMeals} { value }
  ${APPLICATION.makeSpecialMeals} { value }
`;

export const ALLERGIES_FIELDS = `
  ${APPLICATION.allergicToAnimals} { value }
  ${APPLICATION.allergyDogReaction} { value }
  ${APPLICATION.allergyCatReaction} { value }
  ${APPLICATION.allergyHorseReaction} { value }
  ${APPLICATION.allergyOtherAnimal} { value }
  ${APPLICATION.allergyOtherAnimalExplanation} { value }
  ${APPLICATION.nonAllergicDogBreeds} { value }

  ${APPLICATION.dogIndoorsNotInRoom} { value }
  ${APPLICATION.dogOnlyAtNight} { value }
  ${APPLICATION.dogOccasionallyIndoors} { value }
  ${APPLICATION.dogOutsideOnly} { value }

  ${APPLICATION.catIndoorsNotInRoom} { value }
  ${APPLICATION.catOnlyAtNight} { value }
  ${APPLICATION.catOccasionallyIndoors} { value }
  ${APPLICATION.catOutsideOnly} { value }

  ${APPLICATION.allergicToDust} { value }
  ${APPLICATION.cannotLiveWithCarpet} { value }
  ${APPLICATION.allergicToFood} { value }
  ${APPLICATION.listFoodAllergies} { value }

  ${APPLICATION.allergicToPollen} { value }
`;

export const OTHER_PERSONAL_FIELDS = `
  ${APPLICATION.wearsGlassesOrContacts} { value }
`;
